import "./style.scss";
function Button() {
  return <button className="button">Buscar</button>;
}

export default Button;
